module.exports = __webpack_public_path__ + "img/cup.8868fbb6.png";